const locale = {
    placeholder: 'Valitse aika',
    rangePlaceholder: ['Alkuaika', 'Loppuaika'],
};
export default locale;
